'use strict';
require('jquery');

import { initTabs } from './tabs';

$(document).ready(() => {
  initTabs('#talks-year-tabs .publi-tab-btn', '#talks-tab-content .publi-panel', {
    containerId: 'talks-container',
    showAllClass: 'publi-show-all',
  });
});
